/* spin-wheels.js - Spin the Wheel behaviour */
(function () {
  'use strict';

  // helpers
  function qs(sel, ctx){ return (ctx||document).querySelector(sel); }
  function qsa(sel, ctx){ return Array.from((ctx||document).querySelectorAll(sel)); }
  function on(el, ev, fn){ if(!el) return; el.addEventListener(ev, fn); }
  function nowTs(){ return Date.now(); }
  function setLocal(key, value){ try{ localStorage.setItem(key, JSON.stringify(value)); }catch(e){} }
  function getLocal(key){ try{return JSON.parse(localStorage.getItem(key));}catch(e){return null;} }

  var settingsEl = document.getElementById('sw-settings-json');
  if (!settingsEl) return;
  var S = {};
  try { S = JSON.parse(settingsEl.textContent || '{}'); } catch(e) { console.error('SW: settings JSON parse', e); }

  // elements
  var popup = document.getElementById('spin-wheel-popup');
  var canvas = document.getElementById('sw-wheel-canvas');
  var spinBtn = document.getElementById('sw-spin-btn');
  var closeTop = document.getElementById('sw-close');
  var closeBottom = document.getElementById('sw-close-bottom');
  var resultEl = document.getElementById('sw-result');

  // config
  var TIMER_SECONDS = parseInt(S.timer_seconds || 10, 10) || 10;
  var TRIGGER_TIMER = !!S.trigger_timer;
  var TRIGGER_EXIT = !!S.trigger_exit_intent;
  var TRIGGER_CART = !!S.trigger_cart_open;
  var ONCE_PER_SESSION = !!S.once_per_session;
  var DAILY_COOLDOWN_HOURS = Number(S.daily_cooldown_hours || 0) || 0;
  var SHOW_ON_MOBILE = !!S.show_on_mobile;

  // build rewards from schema keys (detect any reward_label_N entries)
  var rewards = [];
  for (var i = 1; i <= 12; i++) {
    var labelKey = 'reward_label_' + i;
    if (typeof S[labelKey] === 'undefined') break;
    var label = S[labelKey] || ('Reward ' + i);
    var type = S['reward_type_' + i] || 'none';
    var value = (S['reward_value_' + i] || '').toString();
    var probPct = Number(S['reward_prob_' + i] || 0) || 0;
    rewards.push({ label: label, type: type, value: value, probPct: probPct });
  }
  // If admin only created 4 entries, default to 6 in code logic not necessary - just use what they provide.

  // Normalize probabilities into weights
  var totalPct = rewards.reduce(function(acc, r){ return acc + (r.probPct||0); }, 0);
  if (totalPct <= 0) {
    rewards.forEach(function(r){ r.weight = 1 / rewards.length; });
  } else {
    rewards.forEach(function(r){ r.weight = (r.probPct || 0) / totalPct; });
  }

  // global discount codes
  var globalCodes = (S.global_discount_codes || '').toString().split(',').map(function(x){ return x.trim(); }).filter(Boolean);

  rewards.forEach(function(r){
    if (r.type === 'discount' && r.value) {
      var extra = r.value.split(',').map(function(x){ return x.trim(); }).filter(Boolean);
      globalCodes = globalCodes.concat(extra);
    }
  });

  // localStorage keys
  var LS_KEY_SHOWN = 'sw_shown_v2';
  var LS_KEY_LAST_SPIN = 'sw_last_spin_v2';

  // mobile check respect
  if (!SHOW_ON_MOBILE && /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent)) {
    TRIGGER_TIMER = false;
    TRIGGER_EXIT = false;
    TRIGGER_CART = false;
  }

  // canvas
  var ctx = canvas && canvas.getContext && canvas.getContext('2d');
  var size = Math.min(360, canvas.width || 360);
  var center = { x: size/2, y: size/2 };
  var radius = size/2;
  var startAngle = 0;
  var spinning = false;

  // Draw wheel - red & white alternating slices, label rotation
  function drawWheel() {
    if (!ctx) return;
    var segments = Math.max(1, rewards.length);
    var arc = (Math.PI * 2) / segments;
    // ensure canvas pixel ratio for crispness
    var dpr = window.devicePixelRatio || 1;
    if (canvas.width !== size * dpr) {
      canvas.width = size * dpr;
      canvas.height = size * dpr;
      canvas.style.width = size + 'px';
      canvas.style.height = size + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    ctx.clearRect(0,0,canvas.width, canvas.height);

    for (var i = 0; i < segments; i++) {
      var angle = startAngle + (i * arc);
      ctx.beginPath();
      ctx.moveTo(center.x, center.y);
      // alternate red / white
      var color = (i % 2 === 0) ? '#D82027' : '#FFFFFF';
      ctx.fillStyle = color;
      ctx.arc(center.x, center.y, radius, angle, angle + arc);
      ctx.fill();

      // Segment border
      ctx.strokeStyle = '#c9c9c9';
      ctx.lineWidth = 1;
      ctx.beginPath();
      ctx.moveTo(center.x, center.y);
      ctx.arc(center.x, center.y, radius, angle, angle + arc);
      ctx.stroke();

      // Label
      ctx.save();
      ctx.translate(center.x, center.y);
      var textAngle = angle + arc/2;
      ctx.rotate(textAngle);
      ctx.textAlign = 'left';
      ctx.fillStyle = (i % 2 === 0) ? '#fff' : '#111';
      ctx.font = Math.max(11, Math.floor(radius/10)) + 'px sans-serif';
      var text = rewards[i].label || '';
      // measure/truncate if long
      var maxWidth = radius * 0.6;
      var displayText = text;
      // simple truncation
      while (ctx.measureText(displayText).width > maxWidth && displayText.length > 3) {
        displayText = displayText.slice(0, -1);
      }
      if (displayText !== text) displayText = displayText.slice(0, -2) + '…';
      ctx.fillText(displayText, radius * 0.08, 6);
      ctx.restore();
    }

    // Inner circle stroke for visual polish
    ctx.beginPath();
    ctx.arc(center.x, center.y, radius * 0.22, 0, Math.PI*2);
    ctx.fillStyle = 'rgba(0,0,0,0.08)';
    ctx.fill();
  }

  // initial draw
  drawWheel();

  // open/close
  function openPopup(triggerName) {
    if (ONCE_PER_SESSION && getLocal(LS_KEY_SHOWN)) return;
    if (DAILY_COOLDOWN_HOURS > 0) {
      var last = getLocal(LS_KEY_LAST_SPIN);
      if (last && last.timestamp) {
        var elapsed = (nowTs() - last.timestamp) / (1000 * 60 * 60);
        if (elapsed < DAILY_COOLDOWN_HOURS) return;
      }
    }
    popup.classList.remove('sw-hidden');
    popup.setAttribute('aria-hidden', 'false');
    setLocal(LS_KEY_SHOWN, true);
    console.log('Spin Wheel opened by trigger:', triggerName);
  }

  function closePopup() {
    popup.classList.add('sw-hidden');
    popup.setAttribute('aria-hidden', 'true');
  }

  // pick weighted index
  function pickWeightedIndex() {
    var r = Math.random();
    var cum = 0;
    for (var i = 0; i < rewards.length; i++) {
      cum += (rewards[i].weight || 0);
      if (r <= cum) return i;
    }
    return rewards.length - 1;
  }

  // spin animation (smooth + bounce)
  function spinWheelAndReveal() {
    if (spinning) return;
    spinning = true;
    resultEl.textContent = '';

    var selectedIndex = pickWeightedIndex();
    var segments = rewards.length;
    var degreesPerSegment = 360 / segments;

    // randomize full rotations
    var fullRotations = 6 + Math.floor(Math.random() * 4); // 6-9
    var targetDeg = fullRotations * 360 + (selectedIndex * degreesPerSegment) + degreesPerSegment/2;

    var duration = 5200; // ms
    var start = performance.now();
    var initialDeg = (startAngle * 180 / Math.PI) * -1; // current startAngle to degrees

    // easing - easeOutCubic for base then small overshoot for bounce
    function easeOutCubic(t){ return 1 - Math.pow(1 - t, 3); }

    function frame(now) {
      var t = Math.min(1, (now - start) / duration);
      var eased = easeOutCubic(t);
      var currentDeg = initialDeg + (targetDeg - initialDeg) * eased;
      // apply subtle wobble near the end
      if (t > 0.92) {
        var wobble = Math.sin((t - 0.92) * Math.PI * 4) * (1 - t) * 15;
        currentDeg += wobble;
      }
      startAngle = (currentDeg * Math.PI / 180) * -1;
      drawWheel();
      if (t < 1) {
        requestAnimationFrame(frame);
      } else {
        // finalize
        spinning = false;
        revealReward(selectedIndex);
      }
    }
    requestAnimationFrame(frame);
  }

  // copy helper
  function copyToClipboard(text) {
    if (!text) return Promise.resolve();
    if (navigator.clipboard && navigator.clipboard.writeText) return navigator.clipboard.writeText(text);
    var ta = document.createElement('textarea');
    ta.value = text;
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); } catch(e) {}
    document.body.removeChild(ta);
    return Promise.resolve();
  }

  // reveal reward
  function revealReward(index) {
    var r = rewards[index];
    setLocal(LS_KEY_LAST_SPIN, { timestamp: nowTs(), reward: (r && r.label) || null });

    if (!r) { resultEl.textContent = 'Error: no reward found.'; return; }

    if (r.type === 'free_product') {
      var variantId = (r.value || '').trim();
      if (!variantId) {
        resultEl.innerHTML = '🎉 ' + r.label + '! (Admin: add variant ID in settings)';
        return;
      }
      resultEl.innerHTML = '🎉 ' + r.label + '! Adding your free gift to cart…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      }).then(function(resp){
        if (!resp.ok) throw new Error('Add to cart failed');
        return resp.json();
      }).then(function(json){
        resultEl.innerHTML = '🎉 <strong>' + r.label + '</strong> added to your cart. <a class="sw-link" href="/cart">View cart</a>';
      }).catch(function(err){
        console.error(err);
        // fallback: show variant link if possible
        resultEl.innerHTML = '🎉 ' + r.label + '! Could not add to cart automatically. <span style="display:block;margin-top:8px;">Admin: check variant ID or permissions.</span>';
      });
    } else if (r.type === 'discount') {
      var codes = [];
      if (r.value && r.value.trim()) {
        codes = r.value.split(',').map(function(x){ return x.trim(); }).filter(Boolean);
      }
      if (codes.length === 0) codes = globalCodes.slice(0);
      var code = (codes.length > 0) ? codes[Math.floor(Math.random()*codes.length)] : null;
      if (!code) {
        resultEl.textContent = '🎉 ' + r.label + '! (No discount codes configured)';
        return;
      }
      resultEl.innerHTML = '<div>🎉 <strong>' + r.label + '</strong></div>' +
        '<div style="margin-top:8px;">Your code: <strong style="letter-spacing:1px;">' + code + '</strong></div>' +
        '<div style="margin-top:8px;"><button id="sw-copy-code" class="sw-secondary">Copy code</button></div>';
      var cb = document.getElementById('sw-copy-code');
      if (cb) on(cb, 'click', function(){ copyToClipboard(code).then(function(){ cb.textContent = 'Copied!'; }); });
    } else if (r.type === 'free_shipping') {
      var shippingCode = (r.value && r.value.trim()) ? r.value.trim().split(',')[0] : (globalCodes[0] || null);
      if (shippingCode) {
        resultEl.innerHTML = '🚚 Free shipping! Use code: <strong>' + shippingCode + '</strong> <button id="sw-copy-shipping" class="sw-secondary">Copy</button>';
        var c2 = document.getElementById('sw-copy-shipping');
        if (c2) on(c2, 'click', function(){ copyToClipboard(shippingCode).then(function(){ c2.textContent = 'Copied!'; }); });
      } else {
        resultEl.textContent = '🚚 Free shipping! (Admin: add a free-shipping discount code in settings)';
      }
    } else {
      // none
      resultEl.textContent = '☹️ ' + (r.label || 'No luck this time. Try again later!');
    }
  }

  // button press animation: quick pulse then spin
  function handleSpinClick(e) {
    e && e.preventDefault();
    if (spinning) return;
    // tactile feedback
    spinBtn.classList.add('sw-pressing');
    // short press
    setTimeout(function(){
      spinBtn.classList.remove('sw-pressing');
      // add pre-spin pulse
      spinBtn.classList.add('sw-animate');
      setTimeout(function(){
        spinBtn.classList.remove('sw-animate');
        spinWheelAndReveal();
      }, 560); // match CSS pulse duration
    }, 140);
  }

  // events
  on(closeTop, 'click', closePopup);
  on(closeBottom, 'click', closePopup);
  popup.addEventListener('click', function(e){
    if (e.target && e.target.classList && e.target.classList.contains('sw-backdrop')) closePopup();
  });

  on(spinBtn, 'click', handleSpinClick);

  // triggers
  if (TRIGGER_TIMER) {
    setTimeout(function(){ openPopup('timer'); }, TIMER_SECONDS * 1000);
  }

  if (TRIGGER_EXIT) {
    document.addEventListener('mouseleave', function(e){
      if (e.clientY < 0) openPopup('exit-intent');
    });
  }

  if (TRIGGER_CART) {
    document.addEventListener('click', function(e){
      var t = e.target;
      var anchor = t.closest && t.closest('a');
      var couldBeCart = false;
      if (anchor && anchor.getAttribute && anchor.getAttribute('href') && anchor.getAttribute('href').indexOf('/cart') !== -1) couldBeCart = true;
      if (t.closest && (t.closest('[data-cart-toggle]') || t.closest('[data-drawer="cart"]') || t.id === 'cart-icon' || t.classList.contains('cart') )) couldBeCart = true;
      if (couldBeCart) openPopup('cart-open');
    }, true);

    // also listen for submit to cart (best-effort)
    document.addEventListener('submit', function(e){
      var form = e.target;
      if (form && form.getAttribute && form.getAttribute('action') && form.getAttribute('action').indexOf('/cart') !== -1) {
        openPopup('cart-submit');
      }
    }, true);
  }

  // focus trap (lightweight)
  document.addEventListener('focus', function(e){
    if (popup.classList.contains('sw-hidden')) return;
    if (!popup.contains(e.target)) {
      spinBtn.focus();
    }
  }, true);

  // helpers for debugging
  window.swOpen = openPopup;
  window.swClose = closePopup;

})();
